import tabbarManager from './src/tabbarManager'
import tabbar from './src/tabbar'

export default {
    component: tabbar,
    manager: tabbarManager
}



// WEBPACK FOOTER //
// ./src/components/tabbar/index.js